import React from 'react'
import HeaderTwo from '../../components/header/HeaderTwo';
import Footer from '../../components/footer/Footer';
import Breadcrumb from './Breadcrumb';
import BookThreeArea from './BookThreeArea';
import BookThreeRelease from './BookThreeRelease'


function BookThree() {	
  return (
	<>
	<HeaderTwo/>
	<main>
	<Breadcrumb/>
	<BookThreeArea/>
	<BookThreeRelease/>
	</main>
	<Footer/>
	</>
  )
}

export default BookThree